import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld } from 'legacy/lut/store'
import { FC } from 'react'

import { ICountryOfBusinessFilterProps } from './models'

export const CountryOfBusinessFilter: FC<ICountryOfBusinessFilterProps> = ({ filter }) => {
  const countries = lookupGetStateOld().references.countries
  const countryName = countries.find((el) => el.value === filter.value)

  return (
    <span>
      {filter.field} {filter.operator} {countryName ? countryName.name : filter.value}
    </span>
  )
}
